module.exports = __webpack_public_path__ + "static/gemini-7b2378515e4ee70911b8215af304c4f5.webp";